module.exports = __webpack_public_path__ + "static/media/hero.c03737fc.jpg";